<app-header-inner></app-header-inner>
<!-- Blog Post Start -->
<div class="post-single">

    <div class="post-subheader dark-overlay dark-overlay-2" style="background-image: url('assets/img/blog/blog-subheader.jpg')">
      <div class="container">
        <h1>We Are Launching a New Branch, Join Us For a Feast</h1>
        <div class="post-meta">
          <span> <i class="far fa-calendar"></i> <a href="#">January 22, 2020</a> </span>
          <span> <i class="far fa-user"></i> Posted by <a href="#">Fredrick Flow</a> </span>
          <span> <i class="far fa-folder"></i> <a href="#">Restaurant</a> </span>
          <span> <i class="fas fa-hashtag"></i> <a href="#">Opening</a>, <a href="#">Pizzeria</a> </span>
        </div>
      </div>
    </div>

    <!-- Content & Sidebar Start -->
    <div class="section">

      <div class="container">
        <div class="row">
          <!-- Content Start -->
          <div class="col-lg-8">
            <div class="post-content-wrapper">

              <div class="post-content">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type
                  specimen book.
                  It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more
                  recently with
                  desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum
                </p>
                <h4>The Grand Opening</h4>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. <a href="#">Lorem Ipsum has been the industry's</a> standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it
                  to make a type specimen book.
                </p>
                <img src="assets/img/blog/4.jpg" alt="post">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                  galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting
                </p>
                <blockquote>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                </blockquote>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                  galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release
                  of Letraset sheets
                  containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
                <div class="row">
                  <div class="col-md-6">
                    <a href="assets/img/blog/2.jpg" class="gallery-thumb">
                      <img src="assets/img/blog/2.jpg" alt="post">
                    </a>
                  </div>
                  <div class="col-md-6">
                    <a href="assets/img/blog/3.jpg" class="gallery-thumb">
                      <img src="assets/img/blog/3.jpg" alt="post">
                    </a>
                  </div>
                </div>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type
                  specimen book.
                  It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more
                  recently with
                  desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum
                </p>
              </div>

              <!-- About Author Start -->
              <div class="section">
                <div class="about-author">
                  <div class="about-author-inner">
                    <img src="assets/img/people/4.jpg" alt="author">
                    <div class="about-author-content">
                      <h5> <a href="#" title="See All Posts">Joanna Flank</a> </h5>
                      <p>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- About Author End -->

              <!-- Comment List Start -->
              <div class="section pt-0">
                <h4>36 Comments</h4>
                <div class="comments-list">
                  <ul>
                    <li class="comment-item">
                      <img src="assets/img/people/1.jpg" alt="comment author">
                      <div class="comment-body">
                        <h5>Henry Crow</h5>
                        <span>Posted on: January 13 2020</span>
                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form by injected humour, or randomised words which don't look even slightly</p>
                        <a href="#" class="reply-link"> Reply </a>
                      </div>
                    </li>
                    <li class="comment-item">
                      <img src="assets/img/people/2.jpg" alt="comment author">
                      <div class="comment-body">
                        <h5>Ilyn Rodrick</h5>
                        <span>Posted on: January 13 2020</span>
                        <p>All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.</p>
                        <a href="#" class="reply-link"> Reply </a>
                      </div>
                    </li>
                    <li class="comment-item">
                      <img src="assets/img/people/3.jpg" alt="comment author">
                      <div class="comment-body">
                        <h5>Fiyona Lumber</h5>
                        <span>Posted on: January 13 2020</span>
                        <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney
                          College in Virginia</p>
                        <a href="#" class="reply-link"> Reply </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Comment List End -->

              <!-- Comment Form Start -->
              <div class="comment-form section pt-0">
                <h4>Leave a Comment</h4>
                <p>Your email address will not be published. Required fields are marked *</p>
                <form method="post">
                  <div class="row">
                    <div class="col-md-6 form-group">
                      <input type="text" class="form-control" placeholder="Full Name*" name="fname" value="">
                    </div>
                    <div class="col-md-6 form-group">
                      <input type="email" class="form-control" placeholder="Email Address*" name="email" value="">
                    </div>
                    <div class="col-md-12 form-group">
                      <textarea class="form-control" placeholder="Type your comment..." name="comment" rows="7"></textarea>
                    </div>
                  </div>

                  <button type="submit" class="btn-custom primary shadow-none" name="button">Post comment</button>
                </form>
              </div>
              <!-- Comment Form End -->

              <!-- Related Posts Start -->
              <div class="section p-0">
                <h4>Related Posts</h4>

                <div class="related">
                  <!-- Post Start -->
                  <article class="post">
                    <h3 class="post-title"> <a routerLink='/blog-single'>Our all new chicken pizza now available</a> </h3>
                    <div class="post-meta">
                      <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>January 22, 2020</a> </span>
                      <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
                    </div>
                    <div class="post-thumbnail">
                      <a routerLink='/blog-single'><img src="assets/img/blog/6.jpg" alt="post thumbnail"></a>
                    </div>
                    <div class="post-desc">
                      <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
                    </div>
                    <a routerLink='/blog-single' class="read-more">Read More</a>
                  </article>
                  <!-- Post End -->

                  <!-- Post Start -->
                  <article class="post">
                    <h3 class="post-title"> <a routerLink='/blog-single'>Changing the way thin crusts are made</a> </h3>
                    <div class="post-meta">
                      <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>January 24, 2020</a> </span>
                      <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
                    </div>
                    <div class="post-thumbnail">
                      <a routerLink='/blog-single'><img src="assets/img/blog/2.jpg" alt="post thumbnail"></a>
                    </div>
                    <div class="post-desc">
                      <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
                    </div>
                    <a routerLink='/blog-single' class="read-more">Read More</a>
                  </article>
                  <!-- Post End -->

                  <!-- Post Start -->
                  <article class="post">
                    <h3 class="post-title"> <a routerLink='/blog-single'>New cheese rolls are now available</a> </h3>
                    <div class="post-meta">
                      <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>January 27, 2020</a> </span>
                      <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
                    </div>
                    <div class="post-thumbnail">
                      <a routerLink='/blog-single'><img src="assets/img/blog/3.jpg" alt="post thumbnail"></a>
                    </div>
                    <div class="post-desc">
                      <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
                    </div>
                    <a routerLink='/blog-single' class="read-more">Read More</a>
                  </article>
                  <!-- Post End -->

                  <!-- Post Start -->
                  <article class="post">
                    <h3 class="post-title"> <a routerLink='/blog-single'>Rose flavored pizza is going crazy nowdays</a> </h3>
                    <div class="post-meta">
                      <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>February 1, 2020</a> </span>
                      <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
                    </div>
                    <div class="post-thumbnail">
                      <a routerLink='/blog-single'><img src="assets/img/blog/4.jpg" alt="post thumbnail"></a>
                    </div>
                    <div class="post-desc">
                      <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
                    </div>
                    <a routerLink='/blog-single' class="read-more">Read More</a>
                  </article>
                  <!-- Post End -->
                </div>

              </div>
              <!-- Related Posts End -->

            </div>

          </div>
          <!-- Content End -->

          <!-- Sidebar Start -->
          <div class="col-lg-4">
            <app-blog-sidebar></app-blog-sidebar>
          </div>
          <!-- Sidebar End -->

        </div>

      </div>

    </div>
    <!-- Content & Sidebar End -->

  </div>
  <!-- Blog Post End -->
<app-footer></app-footer>